import { defineStore } from 'pinia';
import { useRouter } from 'vue-router';
import { StoreModuleName } from '../../constants';
import { OptionList, ListItem, Tdk } from '~/src/api/modules/certList/types';
import { fetchListlInfo, fetchListlOtherInfo } from '~/src/api/modules/certList';

export const useListStore = defineStore(StoreModuleName.CERTLIST, () => {
  const router = useRouter();
  const optionList = ref<OptionList>({
    cateList: [],
    certValue: {},
    company: {
      hotCompanyList: [],
      otherCompanyList: [],
    },
    levelList: {},
  });
  const searchData = ref<any>({
    jointId: '',
    pid: '0',
    cid: '0',
    tag: '0',
    cv: '',
    page: 1,
  });

  const certList = ref<ListItem[]>([]);
  const certTotal = ref(0);
  const tdk = ref<Tdk>({
    description: '',
    keyword: '',
    title: '',
  });
  const parentCateName = ref('');
  const hotCert = ref<ListItem[]>([]);
  const officeCert = ref<ListItem[]>([]);
  const examArticle = ref<any>([]);
  const commentList = ref<any>([]);

  const getListInfo = () => {
    fetchListlInfo(searchData.value).then(res => {
      optionList.value = res.data.optionList;
      certList.value = res.data.list;
      hotCert.value = res.data.hotCert;
      officeCert.value = res.data.officeCert;
      tdk.value = res.data.tdk;
      parentCateName.value = res.data.parentCateName;
      certTotal.value = res.data.pagination.totalCount;
      examArticle.value = res.data.examArticle;
      commentList.value = res.data.commentList;
    });
  };

  const getOtherData = () => {
    fetchListlOtherInfo(searchData.value).then(res => {
      examArticle.value = res.data.examArticle;
      commentList.value = res.data.commentList;
    });
  };

  const addQueryParam = (key: string, value: string | number) => {
    const currentRoute = router.currentRoute.value;
    const query: any = { ...currentRoute.query };
    query[key] = value;

    if (key === 'pid' && query.cid) {
      query.cid = 0;
    }

    router.replace({
      ...currentRoute,
      query,
    });
  };

  return {
    optionList,
    searchData,
    certList,
    officeCert,
    parentCateName,
    certTotal,
    tdk,
    hotCert,
    examArticle,
    commentList,
    getListInfo,
    // getOtherData,
    addQueryParam,
  };
});
